import { createSagas } from "redux-box";
import { call, put } from "redux-saga/effects";
import swal from "sweetalert2";
import api from "@s/api/pictionary";

export default createSagas({
  REQUEST_IMAGES: function* ({ offset, search, gradeId }) {
    try {
      yield put({ type: "SET_LOADING", isLoading: true });

      let filterString = "";
      if (search) filterString += `&search=${encodeURIComponent(search)}`;
      if (gradeId) filterString += `&grade_id=${gradeId}`;

      const response = yield call(api.getImages, offset, filterString);
      if (response) {
        yield put({ type: "SET_IMAGES", images: response.result || [] });
        yield put({
          type: "SET_PAGINATION",
          pagination: {
            count: response.count,
            next_page: response.next_page,
            prev_page: response.prev_page,
            offset: response.offset,
            has_next: response.has_next,
          },
        });
      }
    } catch (err) {
      console.error("pictionary/REQUEST_IMAGES error:", err);
      swal("Error", "Failed to load images", "error");
    } finally {
      yield put({ type: "SET_LOADING", isLoading: false });
    }
  },

  CREATE_IMAGE: function* ({ payload }) {
    try {
      yield call(api.createImage, payload);
      swal("Success", "Image reference created successfully", "success");
      yield put({ type: "HIDE_MODAL" });
      yield put({ type: "REQUEST_IMAGES", offset: 0, search: "", gradeId: "" });
    } catch (err) {
      const msg = err && err.error_message ? err.error_message : "Failed to create image reference";
      swal("Error", msg, "error");
    }
  },

  UPDATE_IMAGE: function* ({ id, payload }) {
    try {
      yield call(api.updateImageById, id, payload);
      swal("Success", "Image reference updated successfully", "success");
      yield put({ type: "HIDE_MODAL" });
      yield put({ type: "REQUEST_IMAGES", offset: 0, search: "", gradeId: "" });
    } catch (err) {
      const msg = err && err.error_message ? err.error_message : "Failed to update image reference";
      swal("Error", msg, "error");
    }
  },

  DELETE_IMAGE: function* ({ id }) {
    try {
      yield call(api.deleteImageById, id);
      swal("Success", "Image reference deleted successfully", "success");
      yield put({ type: "REQUEST_IMAGES", offset: 0, search: "", gradeId: "" });
    } catch (err) {
      const msg = err && err.error_message ? err.error_message : "Failed to delete image reference";
      swal("Error", msg, "error");
    }
  },
});
